import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Dialog, styled } from '@mui/material';

export const DialogStyled = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.colors.lockedBackground,
  },
  '.MuiPaper-root': {
    border: `${theme.spacing()} solid ${
      theme.palette.colors.onSecondaryAndDetailBackground
    }`,
    backgroundColor: theme.palette.colors.primaryBackground,
  },
}));

export const IconStyledBox = styled(Box)(() => ({
  justifyContent: 'center',
  display: 'flex',
}));

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: 48,
  color: theme.palette.colors.mainFocused,
  height: 48,

  [theme.breakpoints.down('sm')]: {
    fontSize: 24,
    color: theme.palette.colors.mainFocused,
    height: 24,
  },
}));

export const BoxTitleMessageStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  justifyContent: 'center',
  display: 'flex',
  marginTop: theme.spacing(2),
}));

export const BoxCancelMessageStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.colors.onSecondaryAndDetailBackground,

  justifyContent: 'center',
  display: 'flex',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  fontSize: '14px',
}));
